import { GetInTouchBannerWrapper } from './style';
import { GetInTouchButton } from '@components/GetInTouchBanner/GetInTouchButton';

import type React from 'react';

interface GetInTouchBannerProps {
  title?: string;
  buttonText: string;
  avatarUrl?: string;
  className?: string;
}

export const GetInTouchBanner: React.FC<GetInTouchBannerProps> = ({ buttonText, className }) => {
  return (
    <GetInTouchBannerWrapper className={className}>
      <GetInTouchButton buttonText={buttonText} />
    </GetInTouchBannerWrapper>
  );
};
